module.exports = __webpack_public_path__ + "img/plate_driving.e346588f.svg";